import { RepositoryBuilder } from 'alto-orm/lib/orm'

import Client     from 'alto-react-kredit/lib/models/client'
import ClientUser from './user'

ClientAuthRepository = new RepositoryBuilder

ClientAuthRepository.registerRelation(ClientUser, '/auth/crud/users', 'users')
ClientAuthRepository.registerRelation(Client,     '/kredit/crud/clients')

export default ClientAuthRepository # takes backendUrl and auth
